<acf>
  return component('stats', [
    'sub_fields' => [
      repeater_field('boxes', [
        'sub_fields' => [
          text_field('number'),
          text_field('caption'),
          number_field('vertical_offset')
        ]
      ])
    ]
  ]);
</acf>

<script>
  export default {
    props: ['content']
  }
</script>

<template>
  <section class="section" :id="content.field_QuarterAndBox_fragment_id">
    <div class="container">
      <div class="columns is-desktop">
        <div class="column" v-for="box in content.field_Stats_boxes" :key="box.caption">
          <div class="cube" :style="{ marginTop: ($mq.desktop ? box.field_Stats_vertical_offset : 0) + 'px' }">
            <div class="square"><span>{{ box.field_Stats_number }}</span></div>
          </div>
          <div class="caption">{{ box.field_Stats_caption }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    background: $pippin;
  }

  .cube {
    font-size: 2.25rem;
    font-family: 'Separat';
    display: block;
    height: 214px;
    width: 231px;
    max-width: 100%;
    color: $red;
    margin: 0 auto;
  }

  .caption {
    max-width: 231px;
    margin: 0 auto;
  }

  .cube .square {
    width: 185px;
    height: 185px;
    display: flex;
    padding: 0 26px;
    margin-left: auto;
    align-items: center;
    justify-content: center;
  }

  .column:nth-child(3n) .cube {
      background-image: url('../assets/cube-engaged.svg');
  }

  .column:nth-child(3n+1) .cube {
      background-image: url('../assets/cube-reached.svg');
  }

  .column:nth-child(3n+2) .cube {
      background-image: url('../assets/cube-creatin.svg');
  }

</style>



// WEBPACK FOOTER //
// components/Stats.vue